import * as React from 'react';
import Typography from '@mui/material/Typography';

const ID = "4ae60f96-f879-4152-9204-593eae2274cc"

const ArmsIndicator4 = ({ metrics, setMetrics, metricsData }) => {
  const [data, setData] = React.useState(false)

  React.useEffect(() => {
    if (!metrics.find(metric => metric === ID)) {
      metrics.push(ID)
      setMetrics(metrics)
    }

    if (metricsData) {
      setData(metricsData[ID])
    }
  }, [metricsData, metrics, setMetrics])

  return (
    (data === true) ? <Typography style={{ padding: '5px', color: 'green' }} >Open </Typography> :
      <Typography style={{ padding: '5px', color: 'red' }}>Closed </Typography>
  )
}
export default ArmsIndicator4;